var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 3.76471V5.64706H8.66667V3.76471C8.66667 2.72647 7.69505 1.88235 6.5 1.88235C5.30495 1.88235 4.33333 2.72647 4.33333 3.76471ZM2.16667 5.64706V3.76471C2.16667 1.68529 4.10651 0 6.5 0C8.89349 0 10.8333 1.68529 10.8333 3.76471V5.64706C12.0284 5.64706 13 6.49118 13 7.52941V14.1176C13 15.1559 12.0284 16 10.8333 16H2.16667C0.971615 16 0 15.1559 0 14.1176V7.52941C0 6.49118 0.971615 5.64706 2.16667 5.64706Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.051c4fed7f95691366e17914271cf803.svg";
export { ForwardRef as ReactComponent };